<template>
    <div>
        <Layout>
            <h1>ManagerFormCreateTemplate</h1>
        </Layout>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';

export default {
    name: 'ManagerFormCreateTemplate',
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout
    }
};
</script>

<style lang="scss" scoped></style>
